import React from 'react';

function NotFoundPage() {
  return (
    <div className='flex h-screen w-screen items-center justify-center '>
      <div className='text-3xl font-bold'>NotFound</div>
    </div>
  );
}

export default NotFoundPage;
